import { Box, Grid, TextField, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import TextInput from 'components/TextInput/TextInput';
import React, { useEffect, useMemo, useState } from 'react';
import { getAddressSuggestions } from 'store/location/services/getAddressSuggestions';
import { getBusinessContacts } from 'store/projects/services/getBusinessContacts';

function ContactAutocomplete({
  label = 'No label',
  name,
  required,
  options = [],
  value = null, // The value of the input
  onChange = () => {}, // Called when changing input value
  handleSelect = () => {}, // Called when an option is chosen
}) {
  return (
    <Autocomplete
      id="address-autocomplete"
      fullWidth
      getOptionLabel={(option) => option.contact_first_name || option}
      // filterOptions={(x) => x}
      options={options}
      autoComplete
      disableClearable
      includeInputInList
      // filterSelectedOptions
      noOptionsText="Ei tuloksia"
      value={value}
      freeSolo
      onChange={(event, newValue) => {
        handleSelect(newValue);
      }}
      onInputChange={(event, newInputValue) => {
        onChange(event);
      }}
      renderInput={(params) => (
        <TextInput
          label={label}
          name={name}
          fullWidth
          required={required}
          {...params}
          //   endAdornment={!searchText && <Icon path={mdiMagnify} size={1} />}
        />
      )}
      renderOption={(option) => {
        const name = option.contact_first_name + ' ' + option.contact_last_name;
        let rest = '';
        if (option.contact_email) {
          rest += option.contact_email;
        }
        if (option.contact_phone) {
          if (rest.length > 0) {
            rest += ', ';
          }
          rest += option.contact_phone;
        }

        return (
          <Grid container key={option.key}>
            <Grid item xs>
              <Typography noWrap>{name}</Typography>
              <Typography noWrap style={{ fontSize: 'small' }}>
                {rest}
              </Typography>
            </Grid>
          </Grid>
        );
      }}
    />
  );
}

export default ContactAutocomplete;
